// extracted by css-extract-rspack-plugin
export default {"confirm":"Confirm-module__confirm__SVUK5","copilotRun":"Confirm-module__copilotRun__mR9t7"};